import React, { useState, useEffect } from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';
import DataTables from '../../partials/table/DataTables';
import ImportModal from './ImportModal';

const DapodikList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  
  // Kolom untuk datatable
  const columns = [
    {
      name: 'No',
      selector: (row, index) => index + 1,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Nama',
      selector: row => row.nama,
      sortable: true,
    },
    {
      name: 'NISN',
      selector: row => row.nisn,
      sortable: true,
    },
    {
      name: 'Kelas',
      selector: row => row.kelas,
      sortable: true,
    },
    {
      name: 'Status',
      selector: row => row.status,
      sortable: true,
    },
    {
      name: 'Aksi',
      cell: row => (
        <div>
          <Button variant="info" size="sm" className="mr-2">
            <i className="fas fa-eye"></i>
          </Button>
          <Button variant="warning" size="sm" className="mr-2">
            <i className="fas fa-edit"></i>
          </Button>
          <Button variant="danger" size="sm">
            <i className="fas fa-trash"></i>
          </Button>
        </div>
      ),
      width: '150px',
    },
  ];

  // Dummy data untuk contoh
  useEffect(() => {
    setLoading(true);
    // Simulasi fetch data
    setTimeout(() => {
      const dummyData = [
        { id: 1, nama: 'Budi Santoso', nisn: '1234567890', kelas: 'X-A', status: 'Aktif' },
        { id: 2, nama: 'Ani Wijaya', nisn: '0987654321', kelas: 'X-A', status: 'Aktif' },
        { id: 3, nama: 'Citra Dewi', nisn: '2345678901', kelas: 'X-B', status: 'Aktif' },
        { id: 4, nama: 'Dodi Pratama', nisn: '3456789012', kelas: 'X-B', status: 'Aktif' },
        { id: 5, nama: 'Eka Putri', nisn: '4567890123', kelas: 'X-C', status: 'Aktif' },
      ];
      setData(dummyData);
      setLoading(false);
    }, 1000);
  }, []);

  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const handleImportClose = () => {
    setShowImportModal(false);
  };

  const handleImportSubmit = (file) => {
    console.log('File diimpor:', file);
    // Implementasi logika import file
    setShowImportModal(false);
  };

  return (
    <div className="container-fluid mt-4">
      <Card>
        <Card.Header>
          <Row>
            <Col>
              <h5>Data Dapodik</h5>
            </Col>
            <Col className="text-right">
              <Button variant="primary" onClick={handleImportClick}>
                <i className="fas fa-file-import mr-2"></i>
                Import Data
              </Button>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <DataTables
            columns={columns}
            data={data}
            progressPending={loading}
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 25, 50, 100]}
          />
        </Card.Body>
      </Card>

      <ImportModal 
        show={showImportModal} 
        onHide={handleImportClose} 
        onSubmit={handleImportSubmit} 
      />
    </div>
  );
};

export default DapodikList;